import { UNIFORM_PROPS } from 'common/constants/component-props';
import type { BBInheritanceValue, BBStates, BBStylesProp, StoryMediaPlatform, WithStateAndPlatform } from 'types/story';

export function hasLocalStyleAssignment({
	styles,
	property,
	state,
	platform,
}: {
	styles?: WithStateAndPlatform<BBStylesProp>;
	property: string;
	state: BBStates;
	platform: StoryMediaPlatform;
}): boolean {
	const assignments = styles?.[state]?.[platform];
	const value: unknown = assignments ? Object.getOwnPropertyDescriptor(assignments, property)?.value : undefined;
	return value !== undefined && value !== null && value !== '';
}

export const getInheritanceInfo = ({
	currentMediaQuery,
	currentState,
	inheritance,
	propertyName,
	propertyPath,
	hasLocalAssignment,
}: {
	currentMediaQuery: StoryMediaPlatform;
	currentState?: BBStates;
	inheritance?: BBInheritanceValue;
	propertyName: string;
	// Dot-notated path to property in story settings "settings.<path>" or commonly in card data "elements.<path>"
	propertyPath: string;
	hasLocalAssignment?: boolean;
}) => {
	const imq = inheritance?.mq;
	const ist = inheritance?.state;

	const isUniformProp = propertyName in UNIFORM_PROPS || propertyPath?.startsWith('settings.');
	const isDefault = !imq && !ist && !isUniformProp;
	const isInherited = (imq && imq !== currentMediaQuery) || (ist && ist !== currentState);
	const isAssigned = (!isDefault && !isInherited) || isUniformProp;
	const type = isAssigned ? 'assigned' : isInherited ? 'inherited' : 'default';
	const source = inheritance?.source;
	const isLocalSource = source?.kind !== 'preset' && !(source?.kind === 'local' && source.owner === 'master');
	const canReset = isUniformProp || (hasLocalAssignment ?? (isAssigned && isLocalSource));

	return { isDefault, isInherited, isAssigned, isUniformProp, type, canReset };
};
